import Client from '../hooks/useAxios';

// دریافت همه قیمت‌ها
export const getRoomPrices = async () => {
  const response = await Client().get('/roomprice');
  return response.data;
};

// دریافت یک قیمت با ID
export const getRoomPriceById = async (id) => {
  const response = await Client().get(`/roomprice/${id}`);
  return response.data;
};

// ایجاد قیمت جدید
export const createRoomPrice = async (data) => {
  const response = await Client().post('/roomprice', data);
  return response.data;
};

// بروزرسانی قیمت
export const updateRoomPrice = async (id, data) => {
  const response = await Client().put(`/roomprice/${id}`, data);
  return response.data;
};

// حذف قیمت
export const deleteRoomPrice = async (id) => {
  const response = await Client().delete(`/roomprice/${id}`);
  return response.data;
};
